import { createColorClasses } from "@/theme/colors";
import { IconProps } from "@/types";
import clsx from "clsx";

export const CirlceLeftArrow = ({
  width = 24,
  height = 24,
  className,
  color,
  onClick,
  decorative = false,
  ariaLabel = "Left arrow",
}: IconProps) => {
  const classes = createColorClasses({ color });
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="#0066cc"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, classes)}
      onClick={onClick}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 15.5228 15.5228 20 10 20ZM5.7 9.5H15V10.5H5.8L8.8 13.6L8.1 14.3L3.8 10L8.1 5.7L8.8 6.4L5.7 9.5ZM10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1Z"
        fill={color}
      />
    </svg>
  );
};
